import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddProfileDialogComponent } from "../add-profile-dialog/add-profile-dialog.component";

export interface ProfileData {
  profile: string;
  read: boolean;
  create: boolean;
  update: boolean;
  decommission: boolean;
  mandatory: boolean | "N/A";
}

@Component({
  selector: "app-lock-dialog",
  templateUrl: "./lock-dialog.component.html",
  styleUrls: ["./lock-dialog.component.css"],
})
export class LockDialogComponent {
  displayedColumns: string[] = [
    "profile",
    "read",
    "create",
    "update",
    "decommission",
    "mandatory",
  ];

  dataSource: ProfileData[] = [
    {
      profile: "Default with OTHER co...",
      read: false,
      create: false,
      update: false,
      decommission: false,
      mandatory: "N/A",
    },
    {
      profile: "MET",
      read: false,
      create: false,
      update: false,
      decommission: false,
      mandatory: "N/A",
    },
    {
      profile: "Other profiles",
      read: false,
      create: false,
      update: false,
      decommission: false,
      mandatory: "N/A",
    },
  ];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<LockDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { propertyName: string; propertyGroupName: string }
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  onLock(): void {
    console.log("Saved data:", this.dataSource);
    this.dialogRef.close(this.dataSource);
  }

  toggleRead(element: ProfileData) {
    element.read = !element.read;

    if (!element.read) {
      element.create = false;
      element.update = false;
      element.decommission = false;

      if (!element.create && !element.update) {
        element.mandatory = "N/A";
      } else {
        element.mandatory = false;
      }
    }
  }

  toggleCreate(element: ProfileData) {
    element.create = !element.create;
    if (element.create) {
      element.read = true;
    }
    if (!element.create && !element.update) {
      element.mandatory = "N/A";
    } else if (element.mandatory === "N/A") {
      element.mandatory = false;
    }
  }

  toggleUpdate(element: ProfileData) {
    element.update = !element.update;
    if (element.update) {
      element.read = true;
    }
    if (!element.create && !element.update) {
      element.mandatory = "N/A";
    } else if (element.mandatory === "N/A") {
      element.mandatory = false;
    }
  }

  // toggleDecommission(element: ProfileData) {
  //   element.decommission = !element.decommission;

  //   if (element.decommission) {
  //     element.read = true;
  //     element.mandatory = false;
  //   }
  // }
  toggleDecommission(element: ProfileData) {
    element.decommission = !element.decommission;

    if (element.decommission) {
      element.read = true;
      element.mandatory = false;
    }

    if (!element.create && !element.update) {
      element.mandatory = "N/A";
    } else if (element.mandatory === "N/A") {
      element.mandatory = false;
    }
  }

  toggleMandatory(element: ProfileData) {
    if (element.mandatory === "N/A") return;

    element.mandatory = !element.mandatory;

    if (element.mandatory) {
      element.create = true;
      element.update = true;
      element.read = true;
      element.decommission = false;
    }
  }

  openAddProfileDialog(): void {
    const dialogRef = this.dialog.open(AddProfileDialogComponent, {
      width: "400px",
      data: {},
    });

    dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
      if (selectedProfiles && selectedProfiles.length) {
        selectedProfiles.forEach((profile) => {
          const exists = this.dataSource.some(
            (p) => p.profile === profile.name
          );
          if (!exists) {
            this.dataSource.push({
              profile: profile.name,
              read: false,
              create: false,
              update: false,
              decommission: false,
              mandatory: "N/A",
            });
          }
        });

        this.dataSource.sort((a, b) => {
          if (a.profile === "Other profiles") return 1;
          if (b.profile === "Other profiles") return -1;
          return a.profile.localeCompare(b.profile);
        });

        this.dataSource = [...this.dataSource];
      }
    });
  }
}
